export const MastercardAdjustmentReasonsType = [
    "Sin autorización del TH",
    "Actividad sospechosa del comercio",
    "Cambio de Responsabilidad del Chip",
    "Cambio de Responsabilidad del Chip - Fraude por tarjeta extraviada/ robada/ emitida nunca recibida (NRI)",
    "Autorización denegada",
    "Sin autorización",
    "Presentación tardía",
    "Código de transacción incorrecto",
    "Moneda incorrecta",
    "Cuenta incorrecta",
    "Monto incorrecto",
    "Multiplicidad",
    "Pago por otros medios",
    "No se recibió mercancía/ servicio",
    "Transacción recurrente cancelada",
    "No es lo descrito o mercancía/ servicio defectuoso",
    "Mercancía falsificada",
    "Declaraciones engañosas",
    "Crédito no procesado",
    "Mercancía/ servicio cancelado",
    "No se recibió el efectivo o valor de transacción de carga"
  ]


  export const VisaAdjustmentReasonsType = [
    "Cambio de responsabilidad del Chip - Fraude por falsificación",
    "Cambio de responsabilidad del Chip - Fraude no relacionado con falsificación",
    "Fraude - Tarjeta presente",
    "Fraude - Tarjeta no presente",
    "Boletín de Tarjetas canceladas ",
    "Autorización denegada",
    "Sin autorización ",
    "Presentación tardía",
    "Código de transacción incorrecto",
    "Moneda incorrecta",
    "Cuenta incorrecta",
    "Monto incorrecto",
    "Multiplicidad",
    "Pago por otros medios",
    "No se recibió mercancía/ servicio",
    "Transacción recurrente cancelada",
    "No es lo descrito o mercancía/ servicio defectuoso",
    "Mercancía falsificada",
    "Declaraciones engañosas",
    "Crédito no procesado",
    "Mercancía/ servicio cancelado",
    "No se recibió el efectivo o valor de transacción de carga"
  ]